/* eslint-disable react/no-unknown-property */
import React from 'react';
import { Skeleton, TextSkeleton, TypographyName } from '@doveit/bricks';
import * as styles from './AgentProfileBySalesCard.style';

export const AgentProfileBySalesCardSkeleton: React.FC = () => (
  <div
    css={styles.basic}
    $color="neutral"
    $isSkeleton
  >
    <div
      css={styles.icon}
      $color="neutral"
    >
      <Skeleton
        height="4rem"
        width="4rem"
      />
    </div>
    <div css={styles.info}>
      <div css={styles.title}>
        <TextSkeleton typography={TypographyName.HEADING_3} />
      </div>
      <div
        css={styles.description}
        $color="neutral"
      >
        <TextSkeleton
          typography={TypographyName.BODY_SMALL}
          mainWordsInLine={2}
          count={3}
        />
      </div>
    </div>
  </div>
);

export default AgentProfileBySalesCardSkeleton;
